var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "publisher-card-view" }, [
    _c("div", {
      staticClass: "publisher-card-view__cover-img-thumb clickable",
      style: _vm.coverImageStyle,
      on: {
        click: function($event) {
          return _vm.goToMyCardDetails()
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "card-block clickable",
        on: {
          click: function($event) {
            return _vm.goToMyCardDetails()
          }
        }
      },
      [
        _c(
          "h4",
          {
            staticClass: "publisher-card-view__title typography--headline",
            attrs: { title: _vm.card.title }
          },
          [_vm._v("\n      " + _vm._s(_vm.card.title) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "typography--caption" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.getGradeLabel(_vm.card)) +
              " ∙\n      " +
              _vm._s(_vm.getSubjectLabel(_vm.card)) +
              "\n      "
          ),
          _vm.card.chapter_name
            ? _c("span", [
                _vm._v(
                  "\n        ∙ " + _vm._s(_vm.card.chapter_name) + "\n      "
                )
              ])
            : !_vm.isEmpty(_vm.card.core_concept)
            ? _c("span", [
                _vm._v(
                  "\n        ∙ " +
                    _vm._s(_vm.getCoreConceptLabel(_vm.card.core_concept)) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-16" }, [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _vm.card.page_count - _vm.card.quiz_count > 0
                ? _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.card.non_quiz")) +
                        " " +
                        _vm._s(
                          _vm.$t("common.card.count", {
                            cnt: _vm.card.page_count - _vm.card.quiz_count
                          })
                        ) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.card.page_count - _vm.card.quiz_count > 0 &&
              _vm.card.quiz_count > 0
                ? _c("span", [_vm._v("∙")])
                : _vm._e(),
              _vm._v(" "),
              _vm.card.quiz_count > 0
                ? _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.card.quiz")) +
                        " " +
                        _vm._s(
                          _vm.$t("common.card.count", {
                            cnt: _vm.card.quiz_count
                          })
                        ) +
                        "\n        "
                    )
                  ])
                : _c("span", { staticStyle: { color: "transparent" } }, [
                    _vm._v("_")
                  ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("series_cards.meta.card_price", {
                      price: _vm.cardPrice
                    })
                  ) +
                  "\n      "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _c("strong", [
                _vm._v(_vm._s(_vm.getShareLevelLabel(_vm.card.share_level)))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("common.card.updated_at")) +
                  ": " +
                  _vm._s(_vm._f("datetime")(_vm.card.updated_at)) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "publisher-card-view__action" }, [
      _vm.isSeriesCard
        ? _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "IconDropdown",
                { attrs: { dropup: true } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.$emit(
                            "open-remove-from-series-modal",
                            _vm.card.id
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("publishers.card.remove_from_series")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isCardAuthor
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.$emit(
                                "open-remove-card-modal",
                                _vm.card.id
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("common.card.menu.remove")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "button",
            {
              staticClass: "btn btn-inverted-primary",
              on: {
                click: function($event) {
                  return _vm.$emit("open-add-to-series-modal", _vm.card.id)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("publishers.card.add_to_series")) +
                  "\n    "
              )
            ]
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4920eff9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4920eff9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/PublisherCardView.vue
// module id = olR/
// module chunks = 1